import { Taxonomy } from "../categories";

export enum RuleConditionType {
    COUNTERPARTY = "counterparty",
    CATEGORY = "category",
    SUGGESTED_CATEGORY = "suggested_category",
    DESCRIPTION_IS = "description_is",
    DESCRIPTION_INCLUDES = "description_includes",
    AMOUNT = "amount",
    DATE = "date",
    FINANCIAL_ACCOUNTS = "financial_accounts",
    ENTITY = "entity",
}

export enum RuleActionType {
    CATEGORY = "category",
    ENTITY = "entity",
    ACCOUNT_ID = "account_id",
    ACCOUNT_NAME = "account_name",
    CLASS = "class",
    MEMO = "memo",
    COUNTERPARTY = "counterparty",
}

export const BusinessRuleActions = [
    RuleActionType.CATEGORY,
    RuleActionType.ENTITY,
    RuleActionType.CLASS,
    RuleActionType.COUNTERPARTY,
    RuleActionType.MEMO,
];
export const AccountingRuleActions = [
    RuleActionType.ACCOUNT_ID,
    RuleActionType.ACCOUNT_NAME,
];
export interface TransactionRuleActionDefinition {
    actionType: RuleActionType;
    value: string | number | string[];
}
export interface TransactionRuleAction extends TransactionRuleActionDefinition {
    id: string;
}

export enum RuleSource {
    SETTINGS = "settings",
    TRANSACTIONS_FEED = "transactions_feed",
    ACTIONS = "actions",
    ENTITY_MIGRATION = "entity_migration",
}

export interface TransactionRuleGroup {
    id: string;
    workspaceId: string;
    rules?: TransactionRule[];
    name: string;
    icon: string;
    isAccounting: boolean;
    isDefault?: boolean;
    order: number;
}

export interface TransactionRule {
    id: string;
    workspaceId: string;
    groupId: string;
    conditions: TransactionRuleCondition[];
    actions: TransactionRuleAction[];
    source: RuleSource | null;
    order: number;
    isDisabled?: boolean | null;
}

export interface RuleConditionAmount {
    min?: number;
    max?: number;
}

export interface RuleConditionDate {
    after?: string;
    before?: string;
}

export interface TransactionRuleConditionDefinition {
    conditionType: RuleConditionType;
    value:
        | string
        | string[]
        | number
        | number[]
        | Taxonomy
        | RuleConditionAmount
        | RuleConditionDate;
}

export interface TransactionRuleCondition
    extends TransactionRuleConditionDefinition {
    id: string;
}
